import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { useTranslation } from 'react-i18next';
import '../css/pieChart.css';

const data = [
  { name: 'Part 1', value: 1 },
  { name: 'Part 2', value: 1 },
  { name: 'Part 3', value: 1 },
  { name: 'Part 4', value: 1 },
  { name: 'Part 5', value: 1 },
  { name: 'Part 6', value: 1 },
  { name: 'Part 7', value: 1 },
];

const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

const PieChartComponent = () => {
  const [rotationAngle, setRotationAngle] = useState(0);
  const [isRotating, setIsRotating] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChartClick = () => {
    setIsRotating(true);
  };

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  useEffect(() => {
    let rotationInterval;

    if (isRotating) {
      const startTime = Date.now();

      rotationInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = elapsed / 750;
        const newRotation = - progress * 180;
        setRotationAngle(newRotation);

        if (elapsed >= 1000) {
          clearInterval(rotationInterval);
          navigate('/bodyscan');
        }
      }, 16);
    }

    return () => clearInterval(rotationInterval);
  }, [isRotating, navigate]);

  return (
    <div className="pie-chart-container" onClick={handleChartClick}>
      {/* Conteneur de zoom uniquement pour le graphique */}
      <div
        className="pie-chart-responsive"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{        
          transform: `scale(${isHovered ? 1.2 : 1})`,
          transition: 'transform 0.3s ease',
        }}
      >
        <ResponsiveContainer width="100%" height={400} style={{ transform: `rotate(${rotationAngle}deg)` }}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

      <div className="centered-button-container">
        <div className="centered-label">{t('home.quiz.click')}</div>
        <div className="centered-text">Quiz</div>
      </div>
      </div>
      {/* Texte centré, en dehors du conteneur de zoom */}

    </div>
  );
};

export default PieChartComponent;